import { createContext } from "react";

export const cartContext = createContext();

export const categories = [
  {
    slug: "laptops",
    name: "Laptops",
    url: "https://dummyjson.com/products/category/laptops",
  },
  {
    slug: "mens-shirts",
    name: "Mens Shirts",
    url: "https://dummyjson.com/products/category/mens-shirts",
  },
  {
    slug: "mens-shoes",
    name: "Mens Shoes",
    url: "https://dummyjson.com/products/category/mens-shoes",
  },
  {
    slug: "mens-watches",
    name: "Mens Watches",
    url: "https://dummyjson.com/products/category/mens-watches",
  },
  {
    slug: "mobile-accessories",
    name: "Mobile Accessories",
    url: "https://dummyjson.com/products/category/mobile-accessories",
  },

  {
    slug: "smartphones",
    name: "Smartphones",
    url: "https://dummyjson.com/products/category/smartphones",
  },

  {
    slug: "sunglasses",
    name: "Sunglasses",
    url: "https://dummyjson.com/products/category/sunglasses",
  },
  {
    slug: "tablets",
    name: "Tablets",
    url: "https://dummyjson.com/products/category/tablets",
  },
];
